var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3127 13.5H17.8127C18.2105 13.5 18.5921 13.342 18.8734 13.0607C19.1547 12.7794 19.3127 12.3978 19.3127 12C19.3127 11.6022 19.1547 11.2206 18.8734 10.9393C18.5921 10.658 18.2105 10.5 17.8127 10.5H4.3127C2.7002 10.5 1.3877 11.8406 1.3877 13.5C1.3877 15.1594 2.7002 16.5 4.3127 16.5H18.0002C19.1937 16.5 20.3383 16.0259 21.1822 15.182C22.0261 14.3381 22.5002 13.1935 22.5002 12C22.5002 10.8065 22.0261 9.66193 21.1822 8.81802C20.3383 7.97411 19.1937 7.5 18.0002 7.5H7.5002",
    stroke: "#007AFF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaperclip);
export default __webpack_public_path__ + "static/media/ico-paperclip.431818b1.svg";
export { ForwardRef as ReactComponent };